export default function FooterApp(){
    return(
      <div className='footer'>
        <p>© 2023 Copyright:</p>
        <a className='footer_link' href='https://lagrilla.online/'> lagrilla.online</a>
      </div>
    );
  
  }